import React, { Fragment, useState, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import logoPaymaya from "../images/paymaya-logo.png";
import logoMyeg from "../images/myeg-logo.jpg";
import logoUnionBank from "../images/ub-logo.png";
import logoMultisys from "../images/multisys.png";
import logoStarPay from "../images/starpay-logo.jpg";
import { currencyFormat } from "./component";
import QRCode from "qrcode";
import { Dialog, Transition } from "@headlessui/react";
import {
  InputDialog,
  regexMobile,
  regexEmail,
} from "../component/form-control";
import { useNavigate } from "react-router-dom";

export const DiagPayment = (props) => {
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);

  const [first_name, setFirst_name] = useState();
  const [last_name, setLast_name] = useState();
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();
  const [valid_email, setValid_email] = useState(false);
  const [valid_mobile, setValid_mobile] = useState(false);
  const [agree, setAgree] = useState(false);
  const [pgw_options, setPgw_options] = useState();

  const params = {
    first_name,
    last_name,
    mobile,
    email,
    valid_email,
    valid_mobile,
    agree,
  };

  const isDisable = !(
    first_name &&
    last_name &&
    mobile &&
    email &&
    valid_email &&
    valid_mobile &&
    agree
  );

  useEffect(() => {
    if (email) {
      setValid_email(regexEmail.test(email));
    }
  }, [email]);

  useEffect(() => {
    if (mobile) {
      setValid_mobile(regexMobile.test(mobile));
    }
  }, [mobile]);

  useEffect(() => {
    if (open) {
      setFirst_name(null);
      setLast_name(null);
      setEmail(null);
      setMobile(null);
      setAgree(false);

      const opt = props.options.filter((_) => _.type === props.pgw)[0];
      setPgw_options(opt);
    }
  }, [open]);

  return (
    <Fragment>
      <a
        href=""
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
        className="p-2 w-32 hover:border rounded hover:bg-green-100"
      >
        {props.pgw === "paymaya" && (
          <img src={logoPaymaya} alt="logo" className="h-full mx-auto" />
        )}
        {props.pgw === "myeg" && (
          <img src={logoMyeg} alt="logo" className="h-full mx-auto" />
        )}
        {props.pgw === "union-bank" && (
          <img src={logoUnionBank} alt="logo" className="h-full mx-auto" />
        )}
        {props.pgw === "multi-sys" && (
          <img src={logoMultisys} alt="logo" className="h-full mx-auto" />
        )}
        {props.pgw === "starpay" && (
          <img src={logoStarPay} alt="logo" className="h-full  mx-auto" />
        )}
      </a>

      <form autoComplete="off" method="POST">
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="fixed z-10 inset-0 overflow-y-auto"
            initialFocus={cancelButtonRef}
            onClose={setOpen}
          >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                  <div className="bg-white">
                    <div className="">
                      <div className="text-center w-full border-b bg-white">
                        <Dialog.Title
                          as="h3"
                          className="text-lg leading-6 font-medium h-20"
                        >
                          {props.pgw === "paymaya" && (
                            <img
                              src={logoPaymaya}
                              alt="logo"
                              className="h-full  mx-auto"
                            />
                          )}

                          {props.pgw === "myeg" && (
                            <img src={logoMyeg} alt="logo" className="h-full" />
                          )}
                          {props.pgw === "union-bank" && (
                            <img
                              src={logoUnionBank}
                              alt="logo"
                              className="h-full mx-auto"
                            />
                          )}
                          {props.pgw === "multi-sys" && (
                            <img
                              src={logoMultisys}
                              alt="logo"
                              className="h-full  mx-auto"
                            />
                          )}
                          {props.pgw === "starpay" && (
                            <img
                              src={logoStarPay}
                              alt="logo"
                              className="h-full  mx-auto"
                            />
                          )}
                        </Dialog.Title>
                      </div>
                      <div className="mt-2 grid grid-cols-3 gap-2 p-5 border-b mb-3">
                        <InputDialog
                          name="first_name"
                          type="text"
                          max="50"
                          onChange={setFirst_name}
                          value={first_name}
                          label="First name"
                          required={true}
                        />

                        <InputDialog
                          name="last_name"
                          type="text"
                          max="50"
                          onChange={setLast_name}
                          value={last_name}
                          label="Last name"
                          required={true}
                        />

                        <InputDialog
                          name="mobile"
                          type="number"
                          max="13"
                          onChange={setMobile}
                          value={mobile}
                          label="Mobile Number"
                          valid={valid_mobile}
                          required={true}
                          isMobile={true}
                        />

                        <InputDialog
                          name="email"
                          type="email"
                          max="100"
                          onChange={setEmail}
                          value={email}
                          label="Email Address"
                          valid={valid_email}
                          required={true}
                          isEmail={true}
                        />
                        {pgw_options && pgw_options.withConvinienceFee && (
                          <div className="col-span-3 text-center text-sm text-red-600 pt-2">
                            <em>
                              A convenience fee of{" "}
                              <span className="text-orange-500 font-bold">
                                Php {currencyFormat(pgw_options.convenienceFee)}
                              </span>{" "}
                              will be applied.
                            </em>
                          </div>
                        )}
                      </div>

                      <div className="px-5 text-sm w-full mb-5">
                        <p className="indent-10 text-justify">
                          I hereby authorize the City Government of Parañaque to
                          collect and process the data indicated in this form, I
                          understand that my personal information is protected
                          by{" "}
                          <strong>
                            R.A. No. 10173 - "Data Privacy Act of 2012"
                          </strong>{" "}
                          and that I am required to provide truthful information
                          in processing my application with regard to payment of
                          Local Government taxes, dues, and fees.
                        </p>
                        <div className="mt-2 flex">
                          <label className="cursor-pointer mx-auto">
                            <input
                              type="checkbox"
                              name="agree"
                              checked={agree}
                              onChange={(e) => setAgree(e.target.checked)}
                              className="mr-2"
                            />
                            <span>I Agree</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 pb-3 border-t text-center">
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => props.proceed(params, props.pgw, setOpen)}
                      disabled={isDisable}
                      className={`cursor-pointer w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm ${
                        isDisable
                          ? "bg-gray-100 "
                          : "bg-sky-600 hover:bg-sky-700"
                      }`}
                    >
                      Continue Payment
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
      </form>
    </Fragment>
  );
};

export const DiagQRCode = (props) => {
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      console.clear();
      console.log(props.DiagPayment);
      if (props.data) {
        const canvas = document.getElementById("qr-code-data");
        QRCode.toCanvas(canvas, props.data, (err) => {
          if (err) console.log(err);
        });
      }
    }
  }, [open]);

  return (
    <Fragment>
      <a
        id="open-qrcode"
        href="#!"
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
      ></a>

      <form autoComplete="off" method="POST">
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="fixed z-10 inset-0 overflow-y-auto"
            initialFocus={cancelButtonRef}
            onClose={setOpen}
          >
            <div className="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle ">
                  <div className="bg-white">
                    <div className="text-center w-full border-b bg-white-100 p-2">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900 h-20"
                      >
                        <img
                          src={logoStarPay}
                          alt="logo"
                          className="h-full mx-auto"
                        />
                      </Dialog.Title>
                    </div>
                    <div className="w-full text-center p-2 text-gray-400">
                      Scan QR Code to Pay
                    </div>
                    <div className="w-full">
                      <canvas id="qr-code-data" className="mx-auto"></canvas>
                    </div>

                    <em className="text-sm text-center px-4">
                      Once payment is done, please close the dialog box.
                    </em>
                  </div>
                  <div className="bg-gray-50 px-4 py-2 pb-3 border-t w-full">
                    <button
                      type="button"
                      className="mx-auto rounded-md border border-gray-300 shadow-sm bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 "
                      onClick={() => navigate("/payment")}
                      ref={cancelButtonRef}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
      </form>
    </Fragment>
  );
};
